<template>
  <div class="add-wardrobe-product-button-container">
    <b-button
      size="md"
      variant="unstitched"
      class="add-item-btn mb-5"
      @click="showAddWardrobeProductModal()"
      :disabled="isFetchingProduct"
    >
      <b-spinner small class="mr-1" v-if="isFetchingProduct"></b-spinner>
      <span>{{ buttonText }}</span>
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bus } from "@/main";

export default {
  mounted() {
    bus.$on("addingWardrobeProduct", isFetching => {
      this.isFetchingProduct = isFetching;
      this.loadingText = this.initialLoadingText;
      this.generateLoadingText;
    });
  },

  data() {
    return {
      isFetchingProduct: false,
      text: "Add item",
      initialLoadingText: "Fetching product...",
      loadingText: "Fetching product..."
    };
  },

  methods: {
    showAddWardrobeProductModal() {
      this.$nextTick(() => {
        this.$bvModal.show("add-wardrobe-product-modal");
      });
    }
  },

  computed: {
    ...mapGetters(["addLayerProductErrors"]),

    buttonText() {
      return this.isFetchingProduct ? this.loadingText : this.text;
    },

    generateLoadingText() {
      let that = this;

      setTimeout(function() {
        that.loadingText = "Processing data...";

        setTimeout(function() {
          that.loadingText = "Saving...";
        }, that.randomTime);
      }, that.randomTime);
    },

    randomTime() {
      const min = 3000;
      const max = 5500;

      return Math.round(Math.random() * (max - min + 1)) + min;
    }
  },

  watch: {
    addLayerProductErrors: {
      handler(errors) {
        errors.forEach((error, index) => {
          if (error.layerId === this.layerId) {
            this.isFetchingProduct = false;
            this.hasErrors = true;
          }
        });
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.add-wardrobe-product-button-container {
  .add-item-btn {
    border-radius: 0;
    padding: 15px;
    font-size: 11px;
    letter-spacing: 1.4px;

    &:hover {
      box-shadow: 0 8px 24px rgba($primary-blue, 0.25);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/buttons/AddWardrobeProductButton.vue